import React, { Children } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Button from '../Button/Button';

/**
 * A component for triggering interactions
 */
function AsLinkButton({ title, ariaLabel, isLoading, onPress, className, children, ...props }) {
  const { t } = useTranslation();

  function generateTitle() {
    if (!title) {
      let strings = [];

      Children.forEach(children, (child) => {
        if (typeof child === 'string') {
          strings.push(child);
        }
      });

      if (strings.length > 0) {
        title = strings[0];
      }
    }

    return title ? `${t('styleguide:link_to')} ${title}` : undefined;
  }

  return (
    <Button
      {...props}
      asLink={true}
      title={generateTitle()}
      ariaLabel={ariaLabel}
      className={className}
      isLoading={isLoading}
      onPress={onPress}
    >
      {children}
    </Button>
  );
}

AsLinkButton.propTypes = {
  /**
   * The title of the button
   */
  title: PropTypes.string,
  /**
   * The classes of the button
   */
  className: PropTypes.string,
  /**
   * The ARIA label of the button
   */
  ariaLabel: PropTypes.string,
  /**
   * The flag for visualising a loading state
   */
  isLoading: PropTypes.bool,
  /**
   * The function to call when pressed
   */
  onPress: PropTypes.func,
  /**
   * The nested children
   */
  children: PropTypes.node.isRequired
};

export default AsLinkButton;
